import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';

export type ITableColumn = IBlockData<
    {
        content?: string;
        'bgcolor'?: string;
    },
    {}
>;

export const TableColumn = createBlock<ITableColumn>({
    get name() {
        return t('Table Column');
    },
    type: BasicType.TABLE_COLUMN,
    create: (payload: any) => {
        const defaultData: ITableColumn = {
            type: BasicType.TABLE_COLUMN,
            data: {
                value: {
                    content: '',
                },
            },
            attributes: {},
            children: [{
                type: 'text',
                data: {
                    value: {
                        content: 'We Serve Healthy &amp; Delicious Foods',
                    },
                },
                attributes: {
                    padding: '10px 25px 10px 25px',
                    align: 'center',
                    color: '#ffffff',
                    'font-size': '45px',
                    'line-height': '45px',
                },
                children: [],
            },],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.TABLE_ROW],
    render(params: any) {
        const { data } = params;
        return (
            <BasicBlock
                params={params}
                tag='td'
            >
                {data.data.value.content}
            </BasicBlock>
        );
    },
});
